module.exports = __webpack_public_path__ + "img/dimas.290bc8fa.png";